<template>

    <router-view/>

</template>

<style lang="scss">
    /*@import "../../assets/css/style.rtl.css";*/
    @import "../../assets/css/site2.css";
    @import "../../assets/css/site.css";
    @import "../../assets/css/custom.rtl.css";
    @import "../../assets/Fonts/iconsax-css/style.css";

    .card .card-header .card-title .card-label {
        margin: 0 !important;
    }

    .aside .aside-secondary .aside-workspace {
        width: 100%;
    }

    @media(min-width: 992px) {

        html[lang="ar"] .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
            left: -125px !important;
        }
        html[lang="en"] .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
            left: 0 !important;
        }
        html[lang="ar"] .aside-enabled.aside-fixed .wrapper {
            padding-left: 0 !important;
            padding-right: 265px;
        }
        html[lang="ar"] .aside-enabled.aside-fixed.toolbar-fixed .toolbar {
            left: 0 !important;
            right: 265px;
        }
        html[lang="ar"] .aside-enabled.aside-fixed.header-fixed .header {
            left: 0 !important;
            right: 265px;
        }

        .aside-fixed .aside {
            left: auto;
            right: 0 !important;
        }
        html[lang="ar"] .aside-fixed.aside-secondary-enabled[data-kt-sticky-header=on] .header {
            left: 0
        }
        html[lang="ar"] .aside-secondary-enabled.aside-fixed .wrapper {
            padding-left: 0;
            padding-right: 275px !important;
        }
        html[lang="ar"] .end-0 {
            left: 0 !important;
            right: auto !important;
        }
    }

    .table > :not(:last-child) > :last-child > * {
        white-space: nowrap;
    }

    @media only screen and (max-width: 768px) {
        .listMobile {
            justify-content: center;
            display: inline-block;
        }
        .listMobile li {
            justify-content: center;
            display: inline-block;
        }
        .hideClassMobile {
            display: none;
        }
    }

    html[lang="ar"] .scrolltop {
        left: 20px;
        right: auto;
    }
</style>

<script>
    import {defineComponent, onMounted, ref} from 'vue';

    export default defineComponent({
        name: 'RTLLayout',
        setup() {
            return {};
        },
    });
</script>